import { render, staticRenderFns } from "./InspirationComment.vue?vue&type=template&id=2033b3cc"
import script from "./InspirationComment.vue?vue&type=script&lang=js"
export * from "./InspirationComment.vue?vue&type=script&lang=js"
import style0 from "./InspirationComment.vue?vue&type=style&index=0&id=2033b3cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports